
<template lang="pug">
div
</template>

<script>
export default {
  props: {
    grid:          Object,
    beginStep:     Number,
    endStep:       Number,
    personIndices: Object,
    dailyTasks:    Array,
    shifts:        Array,
    index:         Number,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  watch: {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="sass">

</style>
